import { ref } from 'vue';

const isDialogOpen = ref(false);

export const useResultDialog = () => {
  const openDialog = () => {
    isDialogOpen.value = true;
  };
  const closeDialog = () => {
    isDialogOpen.value = false;
  };

  return {
    isDialogOpen,
    openDialog,
    closeDialog,
  };
};
